import { render, staticRenderFns } from "./DisperseAdvantage.vue?vue&type=template&id=63ca5704&"
import script from "./DisperseAdvantage.vue?vue&type=script&lang=js&"
export * from "./DisperseAdvantage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports